module.exports = __webpack_public_path__ + "img/img.48c4f769.png";